import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitSelectedAttentionStatusBit = createSelector(
  selectFinancialCockpitState,
  ({ selectedAttentionStatusBit }) => selectedAttentionStatusBit
)
